<script setup lang="ts">
import { Liegenschaft } from '@/models/Liegenschaft'
import LiegenschaftGrid from '@/components/liegenschaft-grid.vue'
import { onMounted, ref, type Ref } from 'vue'

const modelValue = defineModel<boolean>('modelValue')

const { loading = false, liegenschaft = null } = defineProps<{
    loading?: boolean
    liegenschaft?: Liegenschaft
}>()

const emit = defineEmits<{
    (e: 'close'): void
    (e: 'assign', liegenschaft: Liegenschaft | null): void
    (e: 'new-liegenschaft'): void
}>()

const newLiegenschaft: Ref<Liegenschaft | null> = ref(null)

onMounted(() => {
    newLiegenschaft.value = liegenschaft
})

function assign() {
    emit('assign', newLiegenschaft.value)
}
function selectionChanged(liegenschaft: Liegenschaft | null) {
    newLiegenschaft.value = liegenschaft
}
function cancel() {
    newLiegenschaft.value = liegenschaft
    emit('close')
}
</script>

<template>
    <v-dialog v-model:model-value="modelValue" max-width="1000">
        <v-card>
            <slot name="title">
                <v-card-title class="headline">{{ $t('assign_object') }}</v-card-title>
            </slot>
            <slot>
                <v-card-text>
                    <v-card tile height="220px" :loading="loading">
                        <v-card-text>
                            <div v-if="newLiegenschaft">
                                <v-card-title>
                                    {{ newLiegenschaft.strasse }}
                                    {{ newLiegenschaft.strassen_nummer }}
                                    <v-spacer />
                                </v-card-title>
                                <v-card-text>
                                    {{ newLiegenschaft.ort_plz }} {{ newLiegenschaft.ort }}
                                    <br />
                                    {{ $t('gemeinde') }}: {{ newLiegenschaft.gemeinde_bezeichnung }}
                                    <br />
                                    {{ $t('baujahr') }}: {{ newLiegenschaft.baujahr }}
                                    <br />
                                    {{ $t('egid') }}: {{ newLiegenschaft.egid }}
                                    <br />
                                    {{ $t('parzellen_nummer') }}:
                                    {{ newLiegenschaft.parzellen_nummer }}
                                    <br />
                                    {{ $t('assekuranz_nummer') }}:
                                    {{ newLiegenschaft.assekuranz_nummer }}
                                </v-card-text>
                            </div>
                            <div v-else>
                                <v-card-subtitle>{{ $t('choose_object') }}</v-card-subtitle>
                            </div>
                        </v-card-text>
                    </v-card>
                    <LiegenschaftGrid
                        :edit="false"
                        :dense="true"
                        :selectable="true"
                        :height="300"
                        :addbtn="$t('liegenschaft_add')"
                        :selection="newLiegenschaft"
                        @selection="selectionChanged"
                        @new-liegenschaft="$emit('new-liegenschaft')"
                    ></LiegenschaftGrid>
                </v-card-text>
            </slot>
            <slot name="actions">
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="decline" :disabled="loading" @click="cancel">
                        {{ $t('cancel') }}
                    </v-btn>
                    <v-btn
                        color="action"
                        variant="flat"
                        :loading="loading"
                        :disabled="!newLiegenschaft"
                        @click="assign"
                    >
                        {{ $t('assign') }}
                    </v-btn>
                </v-card-actions>
            </slot>
        </v-card>
    </v-dialog>
</template>
